<template>
  <div id="app">
    <div id="loader-wrapper" v-if="fullLoading">
      <i class="el-icon-loading" />
    </div>

    <template v-if="isConstruct">
      <router-view />
    </template>
    <template v-else>
      <Header />
      <div id="main" class="main" :style="{
        height: mainHeight,
      }">
          <router-view />
        <Footer />
      </div>
    </template>

    <el-backtop target="#app" class="toTop">
      <img src="@/assets/toTop.png" />
    </el-backtop>
  </div>
</template>

<script>
import Header from '@/layout/header.vue';
import Footer from '@/layout/footer.vue';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      appInfo: {
        isMobile: document.documentElement.clientWidth < 1000,
        hasScrollbar: false,
        pageScale: 100,
      },
    };
  },
  provide() {
    return {
      reload: this.reload,
      appInfo: this.appInfo,
    };
  },
  computed: { 
    isConstruct() {
      return this.$route.path === '/login';
    },
    ...mapState(['fullLoading']),
    mainHeight() {
      if(this.appInfo.hasScrollbar) {
        return 'calc(100vh - 90px)'
      }
      return 'calc(100vh - 140px)'
    }
  },
  mounted() {
    let getZoom = () => {
      let zoom = 1;
      const screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        zoom = window.devicePixelRatio;
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          zoom = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        zoom = window.outerWidth / window.innerWidth;
      }
      this.appInfo.pageScale = this.appInfo.isMobile ? 100 : Math.round(zoom * 100)
    }
    getZoom()

    window.onresize = () => {
      return (() => {
        this.appInfo.isMobile = document.documentElement.clientWidth < 1000;
        getZoom()
      })();
    };

    const element = document.querySelector(".main");
    const observer = new MutationObserver(() => {
      this.appInfo.hasScrollbar = element.clientHeight !== element.scrollHeight;
    });

    const config = {
      childList: true,
      subtree: true,
    };

    observer.observe(element, config);
  },
  updated() {
  },
  methods: {
    reload() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import './assets/styles/reset.css';

#app {
  font-size: 14px;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  #loader-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background-color: #fff;
    i {
      font-size: 34px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #000;
    }
  }
  .main {
    // ma-top: 90px;
    margin-top: 90px;
    overflow: auto;
  }
  .toTop {
    width: 38px !important;
    height: 38px !important;
    background: #f0f1f5;
    border-radius: 6px !important;
    z-index: 99 !important;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
